import experimentFlagsHelper from '@zola-helpers/client/dist/es/util/experimentFlagsHelper';

// add keys in admin and stage-admin
// Stage-Admin - https://stage-admin.zola.com/experiments
// Admin - https://admin.zola.com/experiments

// Experiment Keys
// export const EXAMPLE_EXPERIMENT = 'example-experiment';
export const SHOP_HOLIDAYS_2022 = 'holidaysShop2022'; // https://newamsterdamlabs.atlassian.net/browse/COMMERCE-2416

const FALLBACK_VARIATIONS = {
  // [EXAMPLE_EXPERIMENT]: experimentFlagsHelper.createExperimentFlags(),
  [SHOP_HOLIDAYS_2022]: experimentFlagsHelper.createExperimentFlags(),
};

export default experimentFlagsHelper.makeExperimentFlags(FALLBACK_VARIATIONS);
